import { type PanelSpan } from '@/components/shared';
import { InterviewDetailPanel } from './InterviewDetailPanelGrid';

export interface InterviewSystemPromptPanelProps {
  systemPrompt: string;
  panelId?: string | undefined;
  currentSpan?: PanelSpan | undefined;
}

export function InterviewSystemPromptPanel({
  systemPrompt,
  panelId,
  currentSpan,
}: InterviewSystemPromptPanelProps) {
  return (
    <InterviewDetailPanel
      title="System prompt"
      span="3x5"
      panelId={panelId}
      currentSpan={currentSpan}
      className="min-h-[48rem]"
      contentClassName="min-h-0 flex-1"
    >
      {systemPrompt.length === 0 ? (
        <div className="rounded-md border border-dashed border-neutral-200 px-4 py-10 text-center text-body text-neutral-500">
          No system prompt available
        </div>
      ) : (
        <div className="h-full min-h-0 overflow-y-auto rounded-md border border-neutral-100 bg-neutral-50 p-4">
          <pre className="whitespace-pre-wrap break-words font-sans text-body leading-6 text-neutral-700">
            {systemPrompt}
          </pre>
        </div>
      )}
    </InterviewDetailPanel>
  );
}
